//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class CoreWebAccountUrlConstants
{
	public static returnUrl: string = `returnUrl`;
	public static apiGetLoginTokenConfirmationUrlTemplate: string = `/api/Login/GetLoginTokenConfirmation?loginTokenGuid=$loginTokenGuid`;
	public static apiCompleteLoginUrlTemplate: string = `/api/CompleteLogin/CompleteLogin?loginTokenGuid=$loginTokenGuid`;
}
